module.exports = __webpack_public_path__ + "static/media/exo-latin-500italic.6c21fc80.woff2";